export default __webpack_public_path__ + "media/images/carousel/31-d0a0d23a24717ec79eb5af1d0fce0209.jpg";